export const normalizeNumber = (x: number | string, digits = 18) => {
  const numberFixed = Number(Number(x).toFixed(digits));

  return numberFixed
    .toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: digits })
    .replace(',', '.');
};
